import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useHeartbeat = () => {
  const router = useRouter();

  useEffect(() => {
    const adminPathRegex = /^\/admin(\/|$)/;
    const excludedPaths = [
      '/admin/invite',
      '/admin/login',
      '/admin/confirm-password',
    ];

    const isAdminPath =
      adminPathRegex.test(router.pathname) &&
      !router.pathname.includes('live-preview') &&
      !excludedPaths.some((path) => router.pathname.startsWith(path));

    const handleRouteChange = async () => {
      try {
        const res = await fetch('/admin/api/auth/heartbeat', {
          method: 'PATCH',
          credentials: 'same-origin',
        });

        if (!res.ok) {
          console.log('Session expired, redirecting to login');
          await fetch('/admin/api/auth/logout', {
            method: 'DELETE',
            credentials: 'same-origin',
          });
          window.location.href = '/login';
        }
      } catch (err) {
        console.error('Heartbeat check failed', err);
        window.location.href = '/login';
      }
    };

    // call this function only when the url contains admin word
    if (isAdminPath) {
      handleRouteChange();
      router.events.on('routeChangeComplete', handleRouteChange);
    }

    // Cleanup function that always removes the event listener
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router]);
};
